import http from './financing-flow.http';
import { FinancingFlowApi } from './financing-flow.types';

export default {
  financings: {
    /**
     * Cancel a project
     * @param financingId
     * @param reason
     * @returns
     */
    cancelByProjectId: async (financingId: number, reason: string) => {
      const res = await http.put<FinancingFlowApi.CancelProjectResponse>(
        `/financing/cancel-not-formalized/${financingId}`,
        { reason },
      );
      return res.data;
    },

    /**
     * Get financing by ID
     * @param financingID
     * @returns
     */
    getByFinancingId: async (financingID: number) => {
      const res = await http.get<FinancingFlowApi.Financing>(`/financing/${financingID}`);
      return res;
    },
    /**
     * Get financing by project ID
     * @param projectID
     * @returns
     */
    getByProjectId: async (projectID: string) => {
      const res = await http.get<FinancingFlowApi.GetByProjectIdResponse>(
        `/financing/by-project-id/${projectID}`,
      );
      return res.data;
    },
    /**
     * Get financing by project ID
     * @param projectID
     * @returns
     */
    getByProjectIdV2: async (projectID: string) => {
      const res = await http.get<FinancingFlowApi.GetByProjectIdResponseV2>(
        `/v2/financing/by-project-id/${projectID}`,
      );
      return res.data;
    },

    /**
     * Get financing list
     * @param params
     * @returns A financing list
     */
    list: async (params: FinancingFlowApi.GetFinancingListRequest) => {
      const url = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => url.append(key, v));
        } else if (value) url.append(key, value);
      });

      const res = await http.get<FinancingFlowApi.GetFinancingListResponse>(
        `/financing/list${url ? `?${url}` : ''}`,
      );
      return res.data;
    },

    /**
     * Get financing list paginated
     * @param params
     * @returns A paginated financing list
     */
    listPaginate: async (params: FinancingFlowApi.GetFinancingPaginatedRequest) => {
      const url = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => url.append(key, v));
        } else if (value) url.append(key, value);
      });

      const endpoint = `/financing/paginated${url ? `?${url}` : ''}`;
      const res = await http.get<FinancingFlowApi.GetFinancingPaginatedResponse>(endpoint);
      return res.data;
    },
  },
};
